import { path } from "ramda";
import verifyOrigin from "common/utils/verifyOrigin";
import getCsrfToken from "common/utils/getCsrfToken";
import initializeVideojs from "./initializeVideojs";
import setupEaseLive from "./setupEaseLive";
import * as persistance from "./persistance";
import { chatIframeActive } from "./store";

let checksTimerId;
let sessionCheckStategy = "POOLING";
let redirectUrl;
let chatIframeActiveUnsubscribe;

function verifyUserToken(url, redirectUrl) {
  return persistance
    .verifyUserToken(url)
    .then((res) => scheduleChecks(url, redirectUrl, res.data.timeout))
    .catch((err) => {
      if (err.response.status === 403) {
        stopViewSession();
      }
    });
}

function stopViewSession() {
  destroy();
  window.location.replace(redirectUrl);
}

function scheduleChecks(url, redirectUrl, timeout = 60000) {
  if (!url || url == "") return;

  timeout = Math.max(parseInt(timeout, 10), 60000);
  checksTimerId = setTimeout(() => verifyUserToken(url, redirectUrl), timeout);
}

function unscheduleChecks() {
  if (sessionCheckStategy === "POOLING") {
    clearTimeout(checksTimerId);
  } else {
    window.removeEventListener("message", handlePostMessage, false);
  }
}

function handleChromecastDisconnected() {
  window.location.reload(false);
}

function handleChromecastConnected() {
  unscheduleChecks();
}

function handlePostMessage(event) {
  // Do we trust the sender of this message?
  if (verifyOrigin(event.origin) === false) return;
  if (!event.data || event.data == "" || typeof event.data != "string") {
    return;
  }

  let data = JSON.parse(event.data);

  if (data.type == "sessionStarted") {
    clearTimeout(checksTimerId);
  } else if (data.type == "sessionEnded") {
    window.removeEventListener("message", handlePostMessage, false);
    stopViewSession();
  }
}

function setupVideojs({
  videojs,
  baseUrl,
  retwitterBaseUrl,
  playlist,
  verifyUserUrl,
  chromecastAppId,
}) {
  let player = initializeVideojs({
    videojs,
    baseUrl,
    retwitterBaseUrl,
    playlist,
    verifyUserUrl,
  });

  // If source contains one video
  if (playlist.length == 1) {
    player.chromecast({
      receiverAppID: chromecastAppId, // dev
      buttonPositionIndex: -1,
    });
  }

  player.on("chromecastConnected", handleChromecastConnected);
  player.on("chromecastDisconnected", handleChromecastDisconnected);
  return { player };
}

function postSetup(obj) {
  let { player } = obj;
  let checkUrl = $("[data-verify-stream]").attr("data-verify-stream");
  let featuresUrl = $("[data-features-url]").attr("data-features-url");
  redirectUrl = $("[data-verify-stream]").attr("data-redirect-to");
  player.ready(() => {
    document.querySelector("#js-video-player").style.opacity = 1;
    document.querySelector(".vjs-tech").style.opacity = 1;
  });

  return Object.assign({}, obj, { checkUrl, featuresUrl, redirectUrl });
}

function addSessionCheck(params) {
  let { featuresUrl, checkUrl, redirectUrl } = params;

  if (featuresUrl == null || featuresUrl == "") return Promise.resolve(params);

  return persistance
    .getFeatures(featuresUrl)
    .then((res) => path(["data", "data", "features"])(res))
    .then((features) => {
      if (features.check_session_using_sockets == true) {
        sessionCheckStategy = "SOCKETS";
        window.removeEventListener("message", handlePostMessage, false);
        window.addEventListener("message", handlePostMessage, false);

        chatIframeActiveUnsubscribe = chatIframeActive.subscribe((val) => {
          if (val === false) {
            stopViewSession();
            chatIframeActiveUnsubscribe();
            chatIframeActiveUnsubscribe = undefined;
          }
        });
      } else {
        scheduleChecks(checkUrl, redirectUrl);
      }
      return { ...params, features };
    })
    .catch(() => {
      scheduleChecks(checkUrl, redirectUrl);
      return params;
    });
}

function playVideo(obj) {
  let { player, playlist } = obj;
  if (playlist.length == 1) {
    player.src(playlist[0].sources[0]);
  } else if (playlist.length > 1) {
    player.playlist?.(playlist);
  }

  player.autoplay("any");
  return obj;
}

function initialize(options) {
  let {
    videojs,
    playlist,
    baseUrl,
    retwitterBaseUrl,
    chromecastAppId,
    verifyUserUrl,
  } = options;
  Promise.resolve({})
    .then(() => {
      let { player } = setupVideojs({
        videojs,
        baseUrl,
        retwitterBaseUrl,
        playlist,
        verifyUserUrl,
        chromecastAppId,
      });
      console.log("setupVideojs");

      return { ...options, player };
    })
    .then((options) => {
      console.log("postSetup");
      return postSetup(options);
    })
    .then(setupEaseLive)
    .then((options) => {
      console.log("addCheck");
      return addSessionCheck(options);
    })
    .then((options) => {
      console.log("playVideo");
      return playVideo(options);
    })
    .catch((res) => {
      console.error("Error during video initialize:", res);
    });

  document.removeEventListener("page:after-remove", destroy);
  document.addEventListener("page:after-remove", destroy);

  document.removeEventListener("page:before-change", destroy);
  document.addEventListener("page:before-change", destroy);
}

function autoInitialize() {
  let videoEl = document.getElementById("js-video-player");
  if (videoEl) {
    initialize({
      videojs,
      videoEl,
      playlist: JSON.parse(videoEl.getAttribute("data-playlist")),
      baseUrl: videoEl.getAttribute("data-base-url"),
      retwitterBaseUrl: $("[data-retwitter-base-url]").attr(
        "data-retwitter-base-url"
      ),
      chromecastAppId: videoEl.getAttribute("data-chromecast-app-id"),
      verifyUserUrl: $("[data-verify-stream]").attr("data-verify-stream"),
    });
  }
}

function destroy() {
  let videoEl = document.getElementById("js-video-player");

  player?.off("chromecastConnected", handleChromecastConnected);
  player?.off("chromecastDisconnected", handleChromecastDisconnected);

  window.videojs?.(videoEl)?.dispose();

  document.removeEventListener("page:after-remove", destroy);
  document.removeEventListener("page:before-change", destroy);

  chatIframeActiveUnsubscribe?.();
}

export function addEventListeners() {
  document.removeEventListener("DOMContentLoaded", autoInitialize);
  document.addEventListener("DOMContentLoaded", autoInitialize);

  document.removeEventListener("page:load", autoInitialize);
  document.addEventListener("page:load", autoInitialize);

  document.removeEventListener("page:restore", autoInitialize);
  document.addEventListener("page:restore", autoInitialize);
}
